<div class="row">
  <div class="col-lg-12">
      <div class="card card-outline-success">
        <div class="card-header">
          <h4 class="m-b-0 text-white">Orden de trabajo</h4>
        </div>
        <div class="card-body">
          <div class="form-body">
            <!-- ================= -->
            <!-- ===== Orden ===== -->
            <!-- ================= -->
            <button class="btn btnImprimirOrdenTrabajo" type="button" data-toggle="modal" data-target="#desplegarDetallesOrden" >Información orden de trabajo</button>
            <div *ngIf="tipoOrden === 'Orden'; else esApoyo">
              <!-- (click)="mapa()" -->
              <br>
              <br>
              <!-- ================================================= -->
              <!-- ===== Listado de producto de abastecimiento ===== -->
              <!-- ================================================= -->
              <table class="table table-striped" border="2">
                <tr class="thead-light">
                  <th colspan="4" style="text-align: center">Entregar o recoger</th>
                </tr>
                <tr>
                  <td>Código</td>
                  <td>Descripción material</td>
                  <td>Cantidades</td>
                  <td>Peso por pieza</td>
                </tr>
                <tr *ngFor="let orden of arrayProductos">
                  <td>{{ orden.codigo }}</td>
                  <td>{{ orden.descripcion }}</td>
                  <td>{{ orden.cantidad }}</td>
                  <td>{{ orden.peso }}</td>
                </tr>
              </table>
              <!-- ================================================= -->
              <!-- ===== Listado de producto de abastecimiento ===== -->
              <!-- ================================================= -->
              <!-- ========================================================= -->
              <!-- ===== Material solicitado por almacén (Tabla verde) ===== -->
              <!-- ========================================================= -->
              <br>
              <table class="table table-success">
                <tr class="tablaMaterialSolicitado">
                  <th colspan="5" style="text-align: center">Material solicitado disponible en almacén</th>
                </tr>
                <tr style="text-align: center">
                  <!-- class="tablaVerdeCampos"  -->
                  <td>Código</td>
                  <td>Descripción material</td>
                  <td>Almacén físico</td>
                  <td>Almacén en obra</td>
                  <td>Cantidad sugerida</td>
                </tr>
                <tr *ngFor="let productoXAlmacen of arrayProductoXAlmacen" style="text-align: center">
                  <td>{{ productoXAlmacen.codigo }}</td>
                  <td>{{ productoXAlmacen.descripcion }}</td>
                  <td>{{ productoXAlmacen.almacenFisico }}</td>
                  <td>{{ productoXAlmacen.almacenObra }}</td>
                  <td>
                    <input class="form-control" style="text-align: center; width: 70px" name="productoXAlmacen.codigo" [(ngModel)]="productoXAlmacen.cantidadSolicitada" (ngModelChange)=mostrarCantidades(productoXAlmacen)>
                  </td>
                </tr>
              </table>
              <!-- ========================================================= -->
              <!-- ===== Material solicitado por almacén (Tabla verde) ===== -->
              <!-- ========================================================= -->
              <!-- =================================================== -->
              <!-- ===== Tabla de material faltante (Tabla roja) ===== -->
              <!-- =================================================== -->
              <table class="table table-danger">
                <tr class="tablaMaterialFaltante">
                  <th colspan="5" style="text-align: center">Cantidad faltante</th>
                </tr>
                <tr style="text-align: center">
                  <!-- class="tablaRojaCampos" -->
                  <td>Código</td>
                  <td>Descripción material</td>
                  <td>Cantidad faltante</td>
                </tr>
                <tr *ngFor="let faltante of arrayTablaRoja" style="text-align: center">
                  <td>{{ faltante.codigo }}</td>
                  <td>{{ faltante.descripcion }}</td>
                  <td>{{ faltante.cantidadFaltante }}</td>
                </tr>
              </table>
              <button class="btn btn-success" (click)="solicitarApoyo()">Solicitar apoyo</button>
              <!-- =================================================== -->
              <!-- ===== Tabla de material faltante (Tabla roja) ===== -->
              <!-- =================================================== -->
            </div>
            <!-- ================= -->
            <!-- ===== Orden ===== -->
            <!-- ================= -->
            <!-- ================= -->
            <!-- ===== Apoyo ===== -->
            <!-- ================= -->
            <ng-template #esApoyo>
              <div>
                <br>
                <table class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                  <tr style="text-align: center">
                    <td>Codigo</td>
                    <td>Descripcion</td>
                    <td>Cantidad enviada</td>
                  </tr>
                  <tr *ngFor="let material of arrayCantidadMaterial" style="text-align: center">
                    <td>{{material.codigo}}</td>
                    <td>{{material.descripcion}}</td>
                    <td>{{material.cantidadApoyoSucursal}}</td>
                  </tr>
                </table>
              </div>
              <div class="float">
                <br>
                <button class="btn btnPrepararMaterial" type="submit" (click)="enReservadoApoyo()">
                  Preparar Material
                </button>
                <button class="btn btnMaterialEnObra" type="submit" (click)="apoyoDeReservadoSuObra()">
                  Material a Obra
                </button>
                <label>Salida de material</label>
                <button class="btn btn-circle btnImprimirSalida btn-lg" type="button" (click)="printMateriales()" data-dismiss="modal"><i class="mdi mdi-printer"></i></button>
                <label>Orden de trabajo</label>
                <button class="btn btn-circle btnImprimirOrdenTrabajo btn-lg" type="button" (click)="printOrden()" data-dismiss="modal"><i class="mdi mdi-printer"></i></button>                  
              </div>
            </ng-template>
            <!-- ================= -->
            <!-- ===== Apoyo ===== -->
            <!-- ================= -->
            <!-- ================================== -->
            <!-- ===== Modal Orden de Trabajo ===== -->
            <!-- ================================== -->
                <div class="modal fade" id="desplegarDetallesOrden" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="float float-right">Orden de trabajo</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <FORM class="form-horizontal form-material">
                                    <div class="row">
                                      <!-- Fecha -->
                                      <div class="col-sm-6 float float-right">
                                        <table class="table" border="2">
                                          <tr>
                                            <td class="thead-light"><strong>Fecha:</strong></td>
                                            <td>{{ fechaYHora }}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Fecha -->
                                      <!-- Jefe de almacén -->
                                      <div class="col-sm-12 float float-right">
                                        <table class="table" border="2">
                                          <tr>
                                            <td><strong>Jefe de almacén:</strong></td>
                                            <td>Agregar: Jefe de almacén</td>
                                            <td><strong>Solicitante:</strong></td>
                                            <td>Agregar: Solicitante</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Jefe de almacén -->
                                      <!-- Horarios y fechas de entregar o recoger -->
                                      <div class="col-sm-12 float float-right">
                                        <table class="table table-striped" border="2">
                                          <tr class="thead-light">
                                            <th colspan="4" style="text-align: center">Horarios y fechas de entrega o recoger</th>
                                          </tr>
                                          <tr>
                                            <td>Entraga de material</td>
                                            <td>Agregar: Entrega de material</td>
                                            <td>Recoger el material</td>
                                            <td>Agregar: Recoger el material</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Horarios y fechas de entregar o recoger -->
                                      <!-- Sucursal fecha y hora -->
                                      <div class="col-sm-12 float float-right">
                                        <table class="table" border="2">
                                          <tr>
                                            <td>Sucursal</td>
                                            <td>{{ nombreSucursal }}</td>
                                            <td>Fecha y hora</td>
                                            <td>{{ fechaYHora }}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Sucursal fecha y hora -->
                                      <!-- Datos del cliente -->
                                      <div class="col-sm-12 float float-right">
                                        <table class="table table-striped" border="2">
                                          <tr class="thead-light">
                                            <th colspan="4" style="text-align: center">Datos cliente</th>
                                          </tr>
                                          <tr>
                                            <td>Cliente</td>
                                            <td>{{ nombreCompleto }}</td>
                                            <td>No. Contrato</td>
                                            <td>{{ noContrato }}</td>
                                          </tr>
                                          <tr>
                                            <td>Obra</td>
                                            <td>{{ obraCotizada }}</td>
                                            <td>No. Cliente</td>
                                            <td>{{ clienteId }}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Datos del cliente -->
                                      <!-- Dirección de entrega o recoger -->
                                      <div class="col-sm-12 float float-right">
                                        <table class="table table-striped" border="2">
                                          <tr class="thead-light">
                                            <th colspan="2" style="text-align: center">Dirección de entrega o recoger</th>
                                          </tr>
                                          <tr>
                                            <td class="bordeCeldas">Dirección de la obra:</td>
                                            <td>{{ obraCotizada }}</td>
                                          </tr>
                                          <tr>
                                            <td class="bordeCeldas">Referencia:</td>
                                            <td>{{ referencia }}</td>
                                          </tr>
                                          <tr>
                                            <td class="bordeCeldas">Tel.:</td>
                                            <td>{{ telefono }}</td>
                                          </tr>
                                          <tr>
                                            <td class="bordeCeldas">Cel.:</td>
                                            <td>{{ celular }}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Dirección de entrega o recoger -->
                                      <!-- ===== Material ===== -->
                                      <!-- Material de mi orden -->
                                      <div class="col-sm-12 float float-right" *ngIf="tipoOrden === 'Orden'; else impresionApoyoOrden">
                                        <table class="table table-striped" border="2">
                                          <tr class="thead-light">
                                            <th colspan="4" style="text-align: center">Entregar o recoger</th>
                                          </tr>
                                          <tr>
                                            <td>Código</td>
                                            <td>Descripción material</td>
                                            <td>Cantidades</td>
                                            <td>Peso por pieza</td>
                                          </tr>
                                          <tr *ngFor="let orden of arrayProductos">
                                            <td>{{ orden.codigo }}</td>
                                            <td>{{ orden.descripcion }}</td>
                                            <td>{{ orden.cantidad }}</td>
                                            <td>{{ orden.peso }}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Material de mi orden -->
                                      <!-- Material para apoyo -->
                                      <ng-template #impresionApoyoOrden>
                                        <div class="col-sm-12 float float-right">
                                          <table class="table table-striped" border="2">
                                            <tr class="thead-light">
                                              <th colspan="3" style="text-align: center">Entregar o recoger</th>
                                            </tr>
                                            <tr>
                                              <td>Código</td>
                                              <td>Descripción material</td>
                                              <td>Cantidades</td>
                                            </tr>
                                            <tr *ngFor="let impreAO of arrayCantidadMaterial">
                                              <td>{{ impreAO.codigo }}</td>
                                              <td>{{ impreAO.descripcion }}</td>
                                              <td>{{ impreAO.cantidadApoyoSucursal }}</td>
                                            </tr>
                                          </table>
                                        </div>
                                      </ng-template>
                                      <!-- Material para apoyo -->
                                      <!-- ===== Material ===== -->
                                      <!-- Notas -->
                                      <div class="col-sm-6 float float-left">
                                        <label>Notas:</label>
                                        <textarea class="form-control notas" cols="50" rows="5"></textarea>
                                      </div>
                                      <!-- Notas -->              
                                      <!-- Total de piezas -->
                                      <div class="col-sm-6 float float-right">
                                        <table class="table table-striped" border="2">
                                          <tr>
                                            <td class="thead-light bordeCeldas"><strong>Total de piezas: </strong></td>
                                            <td>{{ cantidadTotal }}</td>
                                          </tr>
                                          <tr>
                                            <td class="thead-light bordeCeldas"><strong>Unidad recomendada: </strong></td>
                                            <td>{{ vehiculo }}</td>
                                          </tr>
                                          <tr>
                                            <td class="thead-light bordeCeldas"><strong>Total peso (kg.): </strong></td>
                                            <td>{{ rentaPeso }}</td>
                                          </tr>
                                        </table>
                                      </div>
                                      <!-- Total de piezas -->
                                      <!-- Ruta de la obra -->
                                      <div class="col-sm-12 float float-right">
                                        <a style="color: black;" href="{{ mapaGoogle }}" target="_blank">Ruta de la obra (Dirección de GoogleMaps):</a>
                                      </div>
                                      <!--
                                        <div class="col-md-6" id="map" style="height:400px;width: 100%;"></div>
                                      -->
                                      <!-- Ruta de la obra -->
                                    </div>
                                </FORM>
                            </div>
                            <div class="modal-footer" *ngIf="tipoOrden === 'Orden'">
                              <button class="btn btnPrepararMaterial" type="submit" data-dismiss="modal" *ngIf="banderaReservado" (click)="enReservado()">
                              <!-- <i *ngIf="loginLoader" class="fa fa-spinner fa-pulse fa-fw"></i> -->
                                Preparar material
                              </button>
                              <button class="btn btnMaterialEnObra" type="submit" data-dismiss="modal" *ngIf="banderaObra" (click)="enObra()">
                                Material en obra
                              </button>
                              <!--
                                <button class="btn btn-circle btnImprimirSalida btn-lg" type="button" (click)="print()" data-dismiss="modal"><i class="mdi mdi-printer">
                                  </i>
                                </button>
                              -->
                              <label>Salida de material</label>
                              <button class="btn btn-circle btnImprimirSalida btn-lg" type="button" (click)="printMateriales()" data-dismiss="modal"><i class="mdi mdi-printer"></i></button>
                              <label>Orden de trabajo</label>
                              <button class="btn btn-circle btnImprimirOrdenTrabajo btn-lg" type="button" (click)="printOrden()" data-dismiss="modal"><i class="mdi mdi-printer"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ================================== -->
                <!-- ===== Modal Orden de Trabajo ===== -->
                <!-- ================================== -->
                <!-- Mapa -->
                <!--
                <input type="hidden" id="latitudDeSucursal" />
                <input type="hidden" id="longitudDeSucursal" />
                -->
                <!-- Mapa -->
                <!-- ======= -->
                <!-- Botones -->
                <!-- ======= -->
                <div class="col-md-12 float-left">
                    <hr class="mt-5 m-b-40">
                    <div class="form-actions">
                        <div class="col-md-6 col-lg-6">
                        </div>
                    </div>
                </div>
                <!-- ======= -->
                <!-- Botones -->
                <!-- ======= -->
                <!-- ======================= -->
                <!-- ===== IMPRESIONES ===== -->
                <!-- ======================= -->
                <!-- ============================ -->
                <!-- ===== Orden de Trabajo ===== -->
                <!-- ============================ -->
                <div id="print-section2" style="display:none">
                  <!-- Div cabecera-->
                  <div style="float: left; position: relative; width: 100%;">
                    <!-- border: 0.1px solid black; border-collapse: collapse; -->
                    <br/>
                    <table style="width: 100%">
                      <!-- class="tablaMedida" -->
                      <tr style="text-align: center">
                        <th style="text-align: left">
                          <!-- colspan="2" rowspan="4" -->
                          <img src="../../../../assets/images/SM8LogoImp.png" alt="105px" width="130px">
                        </th>
                        <th class="letraImprimir" style="text-align: left"> <h1> ORDEN DE TRABAJO </h1> </th>
                      </tr>
                    </table>
                    <br/>
                  </div>
                  <!-- Div cabecera-->
                  <!-- ===================== -->
                  <!-- ===== Fecha hoy ===== -->
                  <!-- ===================== -->
                  <div style="text-align: right">
                    <br>
                    <table class="table" style="float: right">
                      <!-- border="2" -->
                      <tr style="text-align: right">
                        <td class="thead-light bordeCeldas"><strong>Fecha:</strong></td>
                        <td>{{ fechaYHora }}</td>
                      </tr>
                    </table>
                  </div>
                  <!-- ===================== -->
                  <!-- ===== Fecha hoy ===== -->
                  <!-- ===================== -->
                  <!-- =========================== -->
                  <!-- ===== Jefe de almacén ===== -->
                  <!-- =========================== -->
                  <br>
                  <table class="table" style="width: 100%" border="2">
                    <tr>
                      <td><strong>Jefe de almacén:</strong></td>
                      <td class="bordeCeldas">Agregar: Jefe de almacén</td>
                      <td><strong>Solicitante:</strong></td>
                      <td>Agregar: Solicitante</td>
                    </tr>
                  </table>
                  <br>
                  <!-- =========================== -->
                  <!-- ===== Jefe de almacén ===== -->
                  <!-- =========================== -->
                  <!-- =================================================== -->
                  <!-- ===== Horarios y fechas de entregar o recoger ===== -->
                  <!-- =================================================== -->
                  <table class="table table-striped" style="width: 100%" border="2">
                    <tr class="thead-light">
                      <th colspan="4" style="text-align: center">Horarios y fechas de entrega o recoger</th>
                    </tr>
                    <tr>
                      <td>Entraga de material</td>
                      <td class="bordeCeldas">Agregar: Entrega de material</td>
                      <td>Recoger el material</td>
                      <td>Agregar: Recoger el material</td>
                    </tr>
                  </table>
                  <!-- =================================================== -->
                  <!-- ===== Horarios y fechas de entregar o recoger ===== -->
                  <!-- =================================================== -->
                  <!-- ================================= -->
                  <!-- ===== Sucursal fecha y hora ===== -->
                  <!-- ================================= -->
                  <br>
                  <table class="table" style="width: 100%" border="2">
                    <tr>
                      <td>Sucursal</td>
                      <td class="bordeCeldas">{{ nombreSucursal }}</td>
                      <td>Fecha y hora</td>
                      <td>{{ fechaYHora }}</td>
                    </tr>
                  </table>
                  <br>
                  <!-- ================================= -->
                  <!-- ===== Sucursal fecha y hora ===== -->
                  <!-- ================================= -->
                  <!-- ============================ -->
                  <!-- ===== Datos de cliente ===== -->
                  <!-- ============================ -->
                  <table class="table table-striped" style="width: 100%" border="2">
                    <tr class="thead-light">
                      <th colspan="4" style="text-align: center">Datos cliente</th>
                    </tr>
                    <tr>
                      <td>Cliente</td>
                      <td class="bordeCeldas">{{ nombreCompleto }}</td>
                      <td>No. Contrato</td>
                      <td>{{ noContrato }}</td>
                    </tr>
                    <tr>
                      <td>Obra</td>
                      <td class="bordeCeldas">{{ obraCotizada }}</td>
                      <td>No. Cliente</td>
                      <td>{{ clienteId }}</td>
                    </tr>
                  </table>
                  <br>
                  <!-- ============================ -->
                  <!-- ===== Datos de cliente ===== -->
                  <!-- ============================ -->
                  <!-- ========================================== -->
                  <!-- ===== Dirección de entrega o recoger ===== -->
                  <!-- ========================================== -->
                  <table class="table table-striped" style="width: 100%" border="2">
                    <tr class="thead-light">
                      <th colspan="2" style="text-align: center">Dirección de entrega o recoger</th>
                    </tr>
                    <tr>
                      <td class="bordeCeldas">Dirección de la obra:</td>
                      <td>{{ obraCotizada }}</td>
                    </tr>
                    <tr>
                      <td class="bordeCeldas">Referencia:</td>
                      <td>{{ referencia }}</td>
                    </tr>
                    <tr>
                      <!-- *ngIf="arrayOrden.telefonoCotizado !== ''" -->
                      <td class="bordeCeldas">Tel.:</td>
                      <td>{{ telefono }}</td>
                    </tr>
                    <tr>
                      <!-- *ngIf="arrayOrden.celularCotizado !== ''" -->
                      <td class="bordeCeldas">Cel.:</td>
                      <td>{{ celular }}</td>
                    </tr>
                  </table>
                  <br>
                  <!-- ========================================== -->
                  <!-- ===== Dirección de entrega o recoger ===== -->
                  <!-- ========================================== -->
                  <!-- ============================== -->
                  <!-- ===== Entregar o recoger ===== -->
                  <!-- ============================== -->
                  <!-- Material de mi orden -->
                  <table style="width: 100%" border="2" *ngIf="tipoOrden === 'Orden'; else impresionParaApoyo">
                    <tr>
                      <!-- class="thead-light" -->
                      <th colspan="4" style="text-align: center">Entregar o recoger</th>
                    </tr>
                    <tr>
                      <td>Código</td>
                      <td>Descripción material</td>
                      <td>Cantidades</td>
                      <td>Peso por pieza</td>
                    </tr>
                    <tr *ngFor="let orden of arrayProductos">
                      <td>{{ orden.codigo }}</td>
                      <td>{{ orden.descripcion }}</td>
                      <td style="text-align: center">{{ orden.cantidad }}</td>
                      <td style="text-align: center">{{ orden.peso }}</td>
                    </tr>
                  </table>
                  <!-- Material de mi orden -->
                  <!-- Material para apoyo -->
                  <ng-template #impresionParaApoyo>
                    <table style="width: 100%" border="2">
                      <tr>
                        <!-- class="thead-light" -->
                        <th colspan="4" style="text-align: center">Entregar o recoger</th>
                      </tr>
                      <tr>
                        <td>Código</td>
                        <td>Descripción material</td>
                        <td>Cantidades</td>
                      </tr>
                      <tr *ngFor="let impOrAp of arrayCantidadMaterial">
                        <td>{{ impOrAp.codigo }}</td>
                        <td>{{ impOrAp.descripcion }}</td>
                        <td style="text-align: center">{{ impOrAp.cantidadApoyoSucursal }}</td>
                      </tr>
                    </table>
                  </ng-template>
                  <!-- Material para apoyo -->
                  <!-- ============================== -->
                  <!-- ===== Entregar o recoger ===== -->
                  <!-- ============================== -->
                  <!-- ================= -->
                  <!-- ===== Notas ===== -->
                  <!-- ================= -->
                  <h4>Notas</h4>
                  <div style="float: left">
                    <textarea class="form-control" cols="30" rows="4"></textarea>
                  </div>
                  <!-- ================= -->
                  <!-- ===== Notas ===== -->
                  <!-- ================= -->
                  <!-- =========================== -->
                  <!-- ===== Total de piezas ===== -->
                  <!-- =========================== -->
                  <div class="float float-right">
                    <table style="float: right" border="2">
                      <tr>
                        <td class="thead-light bordeCeldas"><strong>Total de piezas: </strong></td>
                        <td>{{ cantidadTotal }}</td>
                      </tr>
                      <tr>
                        <td class="thead-light bordeCeldas"><strong>Unidad recomendada: </strong></td>
                        <td>{{ vehiculo }}</td>
                      </tr>
                      <tr>
                        <td class="thead-light bordeCeldas"><strong>Total peso (kg.): </strong></td>
                        <td>{{ rentaPeso }}</td>
                      </tr>
                    </table>
                  </div>
                  <!-- =========================== -->
                  <!-- ===== Total de piezas ===== -->
                  <!-- =========================== -->
                  <!-- ================== -->
                  <!-- ===== Firmas ===== -->
                  <!-- ================== -->
                  <div style="float: left; position: relative; width: 100%;">
                    <br>
                    <br>
                    <table class="letraImprimir" style="width: 100%">
                      <tr>
                        <th colspan="2" style="text-align: center">____________________________</th>
                        <th colspan="2" style="text-align: center">____________________________</th>
                      </tr>
                      <tr>
                        <th class="letraImprimir" colspan="2" style="text-align: center">ENTREGO SM8 </th>
                        <th class="letraImprimir" colspan="2" style="text-align: center">FIRMA DE CONFORMIDAD </th>
                      </tr>
                    </table>
                  </div>
                  <!-- ================== -->
                  <!-- ===== Firmas ===== -->
                  <!-- ================== -->
                </div>
                <!-- ============================ -->
                <!-- ===== Orden de Trabajo ===== -->
                <!-- ============================ -->
                <!-- =================================== -->
                <!-- ===== Sólo material necesario ===== -->
                <!-- =================================== -->
                <div id="print-section3" style="display:none">
                  <!-- Div cabecera-->
                  <div style="float: left; position: relative; width: 100%;">
                    <br/>
                    <!--
                      border: 0.1px solid black; border-collapse: collapse;
                    -->
                    <table class="tablaMedida" style="width: 100%; border: 0.1px solid black;">
                      <tr style="text-align: center">
                        <th rowspan="6" style="text-align: left">
                          <!-- colspan="2" rowspan="4" -->
                          <img src="../../../../assets/images/SM8LogoImp.png" alt="105px" width="130px">
                        </th>
                        <th class="letraImprimir"> <strong> Salida de Material por Alquiler </strong> </th>
                      </tr>
                      <tr style="text-align: left">
                        <td class="letraImprimir" style="text-align: left">Cliente: {{ formCliente }}</td>
                        <td colspan="1" class="letraImprimir" style="text-align: center">Almacen: <strong> {{ nombreSucursal }} </strong> </td>
                      </tr>
                      <tr style="text-align: left">
                        <!--
                          <td class="letraImprimir" style="text-align: left">Direccion del cliente: {{ formContacto }} </td>
                        -->
                        <td colspan="2" class="letraImprimir" style="text-align: center">No. de Contrato: {{ noContrato }} </td>
                      </tr>
                      <tr style="text-align: left">
                        <td class="letraImprimir" style="text-align: left">Direccion de la Obra: {{ formDescripcion }}</td>
                        <td colspan="2" class="letraImprimir" style="text-align: center">Fecha: {{ fechaYHora }} </td>
                      </tr>
                    </table>
                    <br>
                    <br>
                  </div>
                  <!-- Div cabecera-->
                  <!-- Material -->
                  <table style="width: 100%">
                    <!--
                      <caption style="border: 0.1px solid black; border-collapse: collapse;">Material</caption>
                    -->
                    <thead>
                      <tr>
                        <th style="text-align: center;">Código</th>
                        <!-- style="font-size: 8px" -->
                        <th style="text-align: center;">Descripción</th>
                        <th style="text-align: center;">Cantidad</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="tipoOrden === 'Orden'; else impresionApoyos">
                      <tr class=letraImprimir style="text-align: center;" *ngFor="let producto of arrayProductos">
                        <td style="text-align: center;"> {{ producto.codigo }} </td>
                        <td style="text-align: center;"> {{ producto.descripcion }} </td>
                        <td style="text-align: center;"> {{ producto.cantidad }} </td>
                      </tr>
                    </tbody>
                    <ng-template #impresionApoyos>
                      <tbody>
                        <tr class=letraImprimir style="text-align: center;" *ngFor="let apoyoImpresion of arrayCantidadMaterial">
                          <td style="text-align: center;"> {{ apoyoImpresion.codigo }} </td>
                          <td style="text-align: center;"> {{ apoyoImpresion.descripcion }} </td>
                          <td style="text-align: center;"> {{ apoyoImpresion.cantidadApoyoSucursal }} </td>
                        </tr>
                      </tbody>
                    </ng-template>
                  </table>
                  <!-- Div Contenedor de Tabalas material-->
                  <div style="float: left; position: relative; width: 100%;">
                    <br/>
                    <br/>
                    <br/>
                  </div>
                  <!-- Div Contenedor de notas y firmas-->
                  <!-- Final impresión -->
                  <div style="background-color: navajowhite ">
                    <!-- Div Contenedor de notas-->
                    <div style="float: left; position: relative; width: 70%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100% ;border: 0.1px solid black; border-collapse: collapse;">
                        <th>NOTAS</th>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                      </table>
                    </div>
                    <!-- Div Contenedor de notas-->
                    <div style="float: left; position: relative; width: 100%;">
                      <br/>
                      <br/>
                      <br/>
                    </div>
                    <!-- Div Contenedor de firmas-->
                    <div style="float: left; position: relative; width: 100%;">
                      <table class="letraImprimir" style="width: 100%">
                        <tr>
                          <th colspan="3" style="text-align: center">____________________________</th>
                          <th colspan="3" style="text-align: center">____________________________</th>
                          <th colspan="3" style="text-align: center">____________________________</th>
                        </tr>
                        <tr>
                          <th class="letraImprimir" colspan="3" style="text-align: center">ENTREGO SM8 </th>
                          <th class="letraImprimir" colspan="3" style="text-align: center">TRANSPORTISTA </th>
                          <th class="letraImprimir" colspan="3" style="text-align: center">FIRMA DE CONFORMIDAD </th>
                        </tr>
                      </table>
                    </div>
                    <!-- Div Contenedor de firmas-->
                  </div>
                  <!-- Final impresión -->
                </div>
                <!-- =================================== -->
                <!-- ===== Sólo material necesario ===== -->
                <!-- =================================== -->
                <!-- =========================== -->
                <!-- ===== Salida material ===== -->
                <!-- =========================== -->
                <div id="print-section" style="display:none">
                  <!-- Div cabecera-->
                  <div style="float: left; position: relative; width: 100%; border: 0.1px solid black; border-collapse: collapse;">
                    <br/>
                    <table class="tablaMedida" style="width: 100%">
                      <tr style="text-align: center">
                        <th rowspan="6" style="text-align: left">
                          <!-- colspan="2" rowspan="4" -->
                          <img src="../../../../assets/images/SM8LogoImp.png" alt="105px" width="130px">
                        </th>
                        <th class="letraImprimir"> <strong> Salida de Material por Alquiler </strong> </th>
                      </tr>
                      <tr style="text-align: left">
                        <td class="letraImprimir" style="text-align: left">Cliente: {{ formCliente }}</td>
                        <td colspan="1" class="letraImprimir" style="text-align: center">Almacen: <strong> {{ nombreSucursal }} </strong> </td>
                      </tr>
                      <tr style="text-align: left">
                        <!--
                          <td class="letraImprimir" style="text-align: left">Direccion del cliente: {{ formContacto }} </td>
                        -->
                        <td colspan="2" class="letraImprimir" style="text-align: center">No. de Contrato: {{ noContrato }} </td>
                      </tr>
                      <tr style="text-align: left">
                        <td class="letraImprimir" style="text-align: left">Direccion de la Obra: {{ formDescripcion }}</td>
                        <td colspan="2" class="letraImprimir" style="text-align: center">Fecha: {{ fechaYHora }} </td>
                      </tr>
                    </table>
                    <br/>
                  </div>
                  <!-- Div cabecera-->
                  <!-- Div Contenedor de Tabalas material-->
                  <!-- SM-8-->
                  <div style="background-color: navajowhite ">
                    <div style="float: left; position: relative; width: 36%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">SM-8</caption>
                        <thead>
                          <tr></tr>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 9">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadSm8">_______</td>
                              <ng-template #cantidadSm8>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>
                              
                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--TUBERIA DIAM 48 MM-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">TUBERIA DIAM 48 MM</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <div class=letraImprimir *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 1">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadTuberia">_______</td>
                              <ng-template #cantidadTuberia>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--CRUCETAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">CRUCETAS</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px;">Código</th>
                            <th style="text-align: center; font-size: 8px;">Descripción</th>
                            <th style="text-align: center; font-size: 8px;">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 6">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadCrucetas">_______</td>
                              <ng-template #cantidadCrucetas>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--VIGADALES Y DUELAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">VIGADALES Y DUELAS</caption>
                        <thead>
                            <tr>
                                <th style="text-align: center; font-size: 8px">Código</th>
                                <th style="text-align: center; font-size: 8px">Descripción</th>
                                <th style="text-align: center; font-size: 8px">Cantidad</th>
                            </tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                        </thead>
                        <tbody>
                            <div *ngFor="let producto of arrayMaterial">
                              <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 10">
                                <td> {{ producto.codigo }} </td>
                                <td> {{producto.descrpcion}} </td>

                                <td *ngIf="producto.cantidad === 0; else cantidadVidalesYDUelas">_______</td>
                                <ng-template #cantidadVidalesYDUelas>
                                  <td style="text-align: center" >{{producto.cantidad}}</td>
                                </ng-template>

                              </tr>
                            </div>
                        </tbody>
                      </table>
                    </div>
                    <!--ACCESORIOS-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">ACCESORIOS</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 8">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadAccesorios">_______</td>
                              <ng-template #cantidadAccesorios>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--VALLAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">VALLAS</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <div style="width: 100%" *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 15">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadVallas">_______</td>
                              <ng-template #cantidadVallas>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--ESCALERA-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">ESCALERA</caption>
                        <thead>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 14">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadEscalera">_______</td>
                              <ng-template #cantidadEscalera>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--RUEDAS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">RUEDAS</caption>
                        <thead>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 7">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadRuedas">_______</td>
                              <ng-template #cantidadRuedas>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--HAMACAS-->
                    <div style="float: left; position: relative; width: 35%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">HAMACAS</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 4">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadHamacas">_______</td>
                              <ng-template #cantidadHamacas>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--BASES-->
                    <div style="float: left; position: relative; width: 28%; border: 0.1px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">BASES</caption>
                        <thead>
                          <tr></tr>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 3">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadBases">_______</td>
                              <ng-template #cantidadBases>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--JUNTAS-->
                    <div style="float: left; position: relative; width: 36%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">JUNTAS</caption>
                        <!--style="position: relative; float: left"-->
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 2">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadJuntas">_______</td>
                              <ng-template #cantidadJuntas>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                      <br/>
                    </div>
                    <!--TARIMAS-->
                    <div style="float: left; position: relative; width: 35%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">TARIMAS</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 13">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadTarimas">_______</td>
                              <ng-template #cantidadTarimas>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                      <br/>
                      <br/>
                    </div>
                    <!--MARCOS-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">MARCOS</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 5">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadMarcos">_______</td>
                              <ng-template #cantidadMarcos>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--TEMPLETE-->
                    <div style="float: left; position: relative; width: 36%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">TEMPLETE</caption>
                        <thead>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 16">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadTemplete">_______</td>
                              <ng-template #cantidadTemplete>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--MATERIAL DE MADERA-->
                    <div style="float: left; position: relative; width: 35%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;">MATERIAL DE MADERA</caption>
                        <thead>
                          <tr></tr>
                          <tr></tr>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 18">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadMaterialMadera">_______</td>
                              <ng-template #cantidadMaterialMadera>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                    <!--ESCALONES-->
                    <div style="float: left; position: relative; width: 28%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100%">
                        <caption style="border: 0.1px solid black; border-collapse: collapse;"> ESCALONES</caption>
                        <thead>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                          <tr>
                            <th style="text-align: center; font-size: 8px">Código</th>
                            <th style="text-align: center; font-size: 8px">Descripción</th>
                            <th style="text-align: center; font-size: 8px">Cantidad</th>
                          </tr>
                          <tr></tr>
                          <tr></tr>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <div *ngFor="let producto of arrayMaterial">
                            <tr style="font-size: 8px" *ngIf="producto.familia.familiaId === 17">
                              <td> {{ producto.codigo }} </td>
                              <td> {{producto.descrpcion}} </td>

                              <td *ngIf="producto.cantidad === 0; else cantidadEscalones">_______</td>
                              <ng-template #cantidadEscalones>
                                <td style="text-align: center" >{{producto.cantidad}}</td>
                              </ng-template>

                            </tr>
                          </div>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- Div Contenedor de Tabalas material-->
                  <div style="float: left; position: relative; width: 100%;">
                    <br/>
                    <br/>
                    <br/>
                  </div>
                  <!-- Div Contenedor de notas y firmas-->
                  <div style="background-color: navajowhite ">
                    <!-- Div Contenedor de notas-->
                    <div style="float: left; position: relative; width: 70%; border: 0.5px solid black; border-collapse: collapse;">
                      <table class="letraImprimir" style="width: 100% ;border: 0.1px solid black; border-collapse: collapse;">
                        <th>NOTAS</th>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                        <tr style="width: 100% ; height: 15px; border: 0.1px solid black;">
                          <th></th>
                        </tr>
                      </table>
                    </div>
                    <!-- Div Contenedor de notas-->
                    <div style="float: left; position: relative; width: 100%;">
                      <br/>
                      <br/>
                      <br/>
                    </div>
                    <!-- Div Contenedor de firmas-->
                    <div style="float: left; position: relative; width: 100%;">
                      <table class="letraImprimir" style="width: 100%">
                        <tr>
                          <th colspan="3" style="text-align: center">____________________________</th>
                          <th colspan="3" style="text-align: center">____________________________</th>
                          <th colspan="3" style="text-align: center">____________________________</th>
                        </tr>
                        <tr>
                          <th class="letraImprimir" colspan="3" style="text-align: center">ENTREGO SM8 </th>
                          <th class="letraImprimir" colspan="3" style="text-align: center">TRANSPORTISTA </th>
                          <th class="letraImprimir" colspan="3" style="text-align: center">FIRMA DE CONFORMIDAD </th>
                        </tr>
                      </table>
                    </div>
                    <!-- Div Contenedor de firmas-->
                  </div>
              </div>
                <!-- =========================== -->
                <!-- ===== Salida material ===== -->
                <!-- =========================== -->
                <!-- ======================= -->
                <!-- ===== IMPRESIONES ===== -->
                <!-- ======================= -->
            </div>
        </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/salidas-material/salidas-material.component.html